import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { StartPurchaseOrForefitProperty } from "../../redux/action/sellerAction";
import { formatPrice } from "../../helpers";
import SocketService from "../../Service/SocketService";
import useTranslationHook from "../hooks/useTranslationHook";
import { createPortal } from "react-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { ForefitModalValidationSchema } from "../../utils/validations";
import { useForm } from "react-hook-form";
import {
    fetchForefitCalulation,
    savePurchaseAgreement,
} from "../../redux/action/buyerAction";
import Shimmer from "./shimmer/Shimmer";
import Input from "./form/Input";
import { guessDateTime } from "../../utils/dateUtils";

const ForefitModal = ({
    show,
    onClose,
    isForeFitted,
    setIsForeFitted,
    setIsPurchased,
    bidPrice,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslationHook();

    const [isSubmiting, setIsSubmiting] = useState(false);
    const { account: isSeller } = useSelector((state) => state.profile);
    const { user_id } = useSelector((state) => state.auth.user) || {};
    let lang = useSelector((state) => state.translation.lang);
    const { id, deposit_amount, auction_unique_id, bidding_end } = useSelector(
        (state) => state.seller.property.propertyData
    );

    const onSubmit = (data) => {
        if (!user_id || isSeller !== 0) navigate("/sign-in");
        setIsSubmiting(true);
        dispatch(StartPurchaseOrForefitProperty(id, 2, data?.signature)).then(
            ({ data }) => {
                if (!data?.error) {
                    SocketService.send("isCallCheckBid", {
                        property_id: id,
                    });
                    setIsForeFitted(true);
                    setIsPurchased(false);
                    SocketService.send("getNotifications", {
                        user_id,
                    });
                }
                onClose();
                setIsSubmiting(false);
            }
        );
    };

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(ForefitModalValidationSchema),
    });

    useEffect(() => {
        document.body.classList.toggle("modal-open", show);
        show && reset();
        return () => {
            document.body.classList.remove("modal-open");
        };
    }, [show]);

    return createPortal(
        <>
            <div
                className={`modal fade  ${show ? "show" : ""} purchase-modal`}
                tabIndex="-1"
            >
                <form
                    onSubmit={handleSubmit(onSubmit)}
                    autoComplete="off"
                    autoCapitalize="off"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header mb-0">
                                <h5 className="modal-title">
                                    {t("Confirm Forfeiture")}
                                </h5>

                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    onClick={onClose}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-4">
                                    <p className="mb0 sky-text">
                                        {
                                            t("You are about to forfeit your winning bid. This action cannot be undone.")
                                        }
                                    </p>
                                </div>

                                <div className="alert alert-red mb-3">
                                    {t(
                                        "Forfeiting your purchase will result in financial penalties and may affect your ability to bid in future auctions."
                                    )}
                                </div>

                                <div className="sky-bg mb-4">
                                    <h6>{t("Applicable Penalties")}</h6>
                                    <table>
                                        {/* <tr>
                                                    <td>
                                                        Forfeit Fee ($
                                                        {forefitCalculation?.forfeit_percentage ||
                                                            t("NA")}
                                                        % of Hammer Price)
                                                    </td>
                                                    <td>
                                                        {t("Amount", {
                                                            amount: formatNumberByLocale(
                                                                Number(
                                                                    forefitCalculation?.forfeit_fee_amount
                                                                ),
                                                                lang
                                                            ),
                                                        })}
                                                    </td>
                                                </tr> */}

                                        <tr>
                                            <td width={"35%"}>
                                                {t("Auction ID")}
                                            </td>
                                            <td width={"65%"}>
                                                {`${auction_unique_id}`}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width={"35%"}>
                                                {t("Auction End Date")}
                                            </td>
                                            <td width={"65%"}>
                                                {` ${guessDateTime(bidding_end, "DD-MM-YYYY", 0, lang)} `}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="pb10">
                                                {t(
                                                    "Non-Refundable Deposit Loss"
                                                )}
                                            </td>
                                            <td>
                                                {t("Amount", {
                                                    amount: formatPrice(
                                                        Number(deposit_amount),
                                                        lang
                                                    ),
                                                })}
                                            </td>
                                        </tr>
                                        <tr className="bdr-t pt-10">
                                            <td className="black-text pt10">
                                                <strong>
                                                    {t("Total Penalty Amount")}
                                                </strong>
                                            </td>
                                            <td>
                                                <strong>
                                                    {t("Amount", {
                                                        amount: formatPrice(
                                                            Math.ceil(
                                                                Number(
                                                                    deposit_amount
                                                                )
                                                            ),
                                                            lang
                                                        ),
                                                    })}
                                                </strong>
                                            </td>
                                        </tr>
                                    </table>
                                </div>

                                <div className="sky-bg mb-4">
                                    <h6>{t("Additional Consequences:")}</h6>
                                    <div className="scroll">
                                        <ul>
                                            <li>
                                                {t("depositNonRefundable", {
                                                    amount: formatPrice(
                                                        Number(
                                                            deposit_amount
                                                        ),
                                                        lang
                                                    ),
                                                })}
                                            </li>

                                            {/* <li>
                                                Your deposit of
                                                <span>
                                                    {" "}
                                                    <em className="dirham">
                                                        D
                                                    </em>{" "}
                                                    {t("Amount", {
                                                        amount: formatNumberByLocale(
                                                            Number(
                                                                deposit_amount
                                                            ),
                                                            lang
                                                        ),
                                                    })}
                                                </span>{" "}
                                                will not be refunded
                                            </li> */}
                                            {/* <li>
                                                You will be billed for the 15%
                                                forfeit fee within 5 business
                                                days
                                            </li> */}
                                            <li>
                                                {t(
                                                    "Your bidding privileges may be suspended pending payment"
                                                )}
                                            </li>
                                            <li>
                                                {
                                                    t("This forfeiture will be recorded in your account history")
                                                }
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <Input
                                        type="text"
                                        id="signature"
                                        className="form-control"
                                        placeholder={t("Type your full name")}
                                        label={t("Digital Signature") + t(" *")}
                                        labelClassname="pb5"
                                        register={register}
                                        errors={errors}
                                        {...register("signature")}
                                    />
                                </div>
                                <p className="sky-text">
                                    {
                                        t("By typing your name, you agree that this constitutes a legal signature.")
                                    }
                                </p>
                                <div className="mb-3">
                                    <input
                                        id="agreement1"
                                        type="checkbox"
                                        className="css-checkbox"
                                        {...register("agreement")}
                                    />
                                    <label
                                        htmlFor="agreement1"
                                        className="css-label"
                                    >
                                        {t(
                                            "I understand and confirm forfeiture, accepting all penalties and consequences listed above"
                                        )}
                                    </label>
                                    {errors?.["agreement"]?.message ? (
                                        <span className="text-danger">
                                            {t(errors["agreement"].message)}
                                        </span>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </div>
                            <div className="d-flex">
                                <button
                                    className="btn btn-sky btn-md width50"
                                    onClick={onClose}
                                    type="button"
                                >
                                    {t("Cancel")}
                                </button>
                                <button
                                    type={"submit"}
                                    className="btn btn-red btn-md width50"
                                    disabled={isSubmiting}
                                >
                                    {isSubmiting
                                        ? t("Submiting")
                                        : t("Confirm Forfeiture")}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>,
        document.getElementById("root")
    );
};

export default ForefitModal;
